export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="w-full lg:w-7/12">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-2.5 h-2.5 rounded-full bg-foreground-900"></span>
              <span className="text-sm font-semibold uppercase tracking-widest text-foreground-500">
                Trusted by Buyers
              </span>
            </div>

            <blockquote className="font-heading text-2xl md:text-4xl font-medium text-foreground-900 leading-relaxed mb-8 before:content-['\u201C'] before:text-primary-500 before:text-6xl before:leading-none before:block">
              The OOPBuy Spreadsheet completely transformed how I browse and organize product sourcing. 
              Instead of jumping between dozens of tabs, everything is structured, searchable, and 
              linked to verified suppliers. It saved me hours every single week.
            </blockquote>

            <div className="flex items-center gap-3">
              <span className="text-sm font-bold text-foreground-900">James R.</span>
              <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium flex items-center gap-1">
                <i className="ri-verified-badge-line text-xs"></i>
                Verified Buyer
              </span>
            </div>
          </div>

          <div className="w-full lg:w-5/12">
            <div className="relative w-full aspect-[3/4] max-w-[380px] mx-auto rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20portrait%20photography%20of%20a%20confident%20professional%20person%20standing%20against%20a%20clean%20warm%20beige%20studio%20backdrop%2C%20soft%20natural%20window%20lighting%20from%20left%2C%20modern%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20three%20quarter%20pose%20with%20relaxed%20crossed%20arms%2C%20genuine%20smile%2C%20professional%20yet%20approachable%20mood%2C%20high%20contrast%2C%20crisp%20detail%2C%20commercial%20headshot%20style&width=760&height=1013&seq=testimonial-v2-01&orientation=portrait"
                alt="Verified OOPBuy Spreadsheet user testimonial"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}